var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('div',{staticClass:"display-1 pl-2"},[_vm._v("Test page")])])],1),_c('v-row',[_c('v-col',[_c('v-divider')],1)],1),_c('v-row',[_c('v-col',[_vm._v(" Test contents ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }